import { motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import * as React from "react";
import { useEffect, useState } from "react";

export default function ToggleTheme() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Load saved theme from local storage
    return localStorage.getItem("theme") === "dark";
  });

  // Apply theme on initial load
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  // Toggle function
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };

  return (
    // <div>
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={() => toggleDarkMode()}
      className="group p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
    >
      {isDarkMode ? (
        <Sun className="h-5 w-5 text-foreground " />
      ) : (
        <Moon className="h-5 w-5 text-foreground " />
      )}
    </motion.button>
    // </div>
  );
}
